export enum ProviderType {
  Msp = 0,
  Reseller = 1,
  MultiOrganizationEnterprise = 2,
}
